module.exports = __webpack_public_path__ + "static/refract-bg_3-3e9329d0e032be461ac0b277b0a30918.webm";